import(/* webpackMode: "eager" */ "/home/ubuntu/download/69887e8e921dc900143642b0/website_project/src/app/admin/page.tsx");
